module.exports = __webpack_public_path__ + "static/nazar_rubashnyy-c225c01bd557d7c06b333a933156b289.png";